export default function () {
  return {
    filters: {
      min_price: null,
      max_price: null,
      unit_price_min: null,
      unit_price_max: null,
      thc_content_min: null,
      thc_content_max: null,
      thc_unit: "%",
      brands: [],
      category_types: [],
      categories: [],
      strain_types: [],
      strains: [],
      production_types: [],
      location_names: [],
      inventory_category_types: [],
      non_metrc_category_groups: [],
      listing_type: null,
      category_types_mode: "include",
      non_metrc_category_groups_mode: "include",
      bucket_ids: [],
    },
    options: {
      min_price: null,
      max_price: null,
      unit_price_min: null,
      unit_price_max: null,
      thc_content_min: null,
      thc_content_max: null,
      thc_unit: "%",
      category_types: [],
      categories: [],
      strain_types: [],
      strains: [],
      production_types: [],
      location_names: [],
      inventory_category_types: [],
      non_metrc_category_groups: [],
      buckets: [],
    }
  };
}
